import React from "react";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import MuiGrid from "@mui/material/Grid";
import { Box } from "@mui/material";
import { Form, useFormContext } from "@programari-limit/base-react";
import GridFormField from "components/GridFormField";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";

const ProveidorForm = () => {
    const { t } = useTranslation();
    const { data } = useFormContext();

    return (
        <MuiGrid container spacing={2} sx={{ mt: 1 }}>
            <GridFormField name="codi" xs={6} lg={1.5} />
            <GridFormField name="nom" xs={6} lg={4.5} />
            <GridFormField name="tipus" xs={6} lg={2} />
            <GridFormField name="estat" xs={6} lg={2} />
            <GridFormField name="nif" xs={6} lg={2} />
            <GridFormField name="carrer" xs={6} lg={7} />
            <GridFormField name="numero" xs={6} lg={1} />
            <GridFormField name="poblacio" xs={6} lg={4} />
            <GridFormField name="telefon" xs={6} lg={3} />
            <GridFormField name="fax" xs={6} lg={3} />
            <GridFormField name="correu_electronic" xs={6} lg={6} />
            <GridFormField name="informacio" xs={6} lg={12} />
            <GridFormField name="dades_contacte" xs={6} lg={4} />
            <GridFormField name="compte_bancari" xs={6} lg={4} />
            <GridFormField name="compte_comptable" xs={6} lg={4} />
            <GridFormField name="observacions" lg={12} />
            <GridFormField name="auditoria" xs={6} lg={4} />
        </MuiGrid>
    );
};

const ProveidorFormContent = () => {
    const { t } = useTranslation();
    const { data } = useFormContext();
    const [value, setValue] = React.useState("0");

    return (
        <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                    onChange={(event, newValue) => setValue(newValue)}
                    aria-label={t("proveidor.title")}
                >
                    <Tab label={t("proveidor.title")} value="0" />
                    {/* <Tab
                        label={t("zonesUser.title")}
                        value={"1"}
                        disabled={!data?.id}
                    /> */}
                </TabList>
            </Box>
            <TabPanel value="0" sx={{ height: "100%", p: 0 }}>
                <ProveidorForm />
            </TabPanel>
            {/* <TabPanel value="1" sx={{ height: "100%", p: 0 }}>
                <ZonesUser userId={data?.id} />
            </TabPanel> */}
        </TabContext>
    );
};

const ProveidorDetall = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();

    return (
        <Box sx={{ display: "flex", height: "100%", flexDirection: "column" }}>
            <Form
                resourceName="proveidor"
                id={id}
                titleCreate={t("proveidor.create")}
                titleUpdate={t("proveidor.update")}
                size="small"
                onGoBack={() => navigate(-1)}
            >
                <ProveidorFormContent />
            </Form>
        </Box>
    );
};
export default ProveidorDetall;
